import { render, staticRenderFns } from "./CompanyPeoplePanel.vue?vue&type=template&id=837ecaa8&scoped=true"
import script from "./CompanyPeoplePanel.vue?vue&type=script&lang=js"
export * from "./CompanyPeoplePanel.vue?vue&type=script&lang=js"
import style0 from "./CompanyPeoplePanel.vue?vue&type=style&index=0&id=837ecaa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837ecaa8",
  null
  
)

export default component.exports